import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import * as actions from "screens/users/actions";
import { Button, Card, FormGroup } from "common";
import { handleInputChange } from "lib/utilities";

class UsersActivate extends Component {
  state = {
    password: "",
    password_confirmation: ""
  };

  handleSubmit = () => {
    const { password } = this.state;
    this.props.createPassword({
      password,
      password_reset: this.props.match.params.id
    });
  };

  render() {
    const { password, password_confirmation } = this.state;
    const areDifferentPasswords = password !== password_confirmation;
    const isDisabled =
      password === "" || password_confirmation === "" || areDifferentPasswords;
    return (
      <Card
        title="Create a Password"
        classes="col-sm-12 col-md-6 offset-md-3"
        padding={4}
      >
        {areDifferentPasswords &&
          password_confirmation.length > 0 && (
            <div className="alert alert-warning">Passwords Must Match</div>
          )}
        <FormGroup
          label="Password"
          type="password"
          value={password}
          onChange={e => handleInputChange(this, e, "password")}
        />
        <FormGroup
          label="Password Confirmation"
          type="password"
          value={password_confirmation}
          onChange={e => handleInputChange(this, e, "password_confirmation")}
        />
        <Button
          onClick={this.handleSubmit}
          disabled={isDisabled}
          grey={isDisabled}
          style={{ marginTop: "10px" }}
        >
          Create Password
        </Button>
      </Card>
    );
  }
}

UsersActivate.propTypes = {
  user: PropTypes.object,
  match: PropTypes.object,
  createPassword: PropTypes.func,
};

const mapStateToProps = ({ user }) => ({ user });

const connected = connect(mapStateToProps, actions)(UsersActivate);

export { connected as UsersActivate };
